import { useWorkspaceAdmin } from '@/features/workspaces/hooks/useWorkspace';
import { Audience } from '@/models/audiences';
import { ConnectorFlowInstanceDTO } from '@/models/connectors';
import { FC } from 'react';
import { AudienceFlowInstanceDisconnectButton } from '../../AudienceFlowInstanceDisconnectButton';

type AudienceFlowInstanceDisconnectColumnProps = {
  audience: Audience;
  flowInstance: ConnectorFlowInstanceDTO;
};

export const AudienceFlowInstanceDisconnectColumn: FC<AudienceFlowInstanceDisconnectColumnProps> = ({ audience, flowInstance }) => {
  const isWorkspaceAdmin = useWorkspaceAdmin();

  return (
    isWorkspaceAdmin && (
      <div className='flex items-center gap-1.5'>
        <AudienceFlowInstanceDisconnectButton audience={audience} flowInstance={flowInstance} />
      </div>
    )
  );
};
